import React, { useState } from "react";
import styles from "./styles.module.css";
import { PantsSalesMap } from "../../salesMap";
import { PlantsTable, TotalPlantsTable } from "../../../tables/index";
import PlantBarChart from "../../../tables/plantstables/salestables";
import ZernoChart from "../../../tables/plantstables/salestables/zerno";
import HlopokChart from "../../../tables/plantstables/salestables/hlopok";
import TabakChart from "../../../tables/plantstables/salestables/tabak";
import PotatoChart from "../../../tables/plantstables/salestables/potato";
import VegetablesChart from "../../../tables/plantstables/salestables/vegetables";
import BahchiChart from "../../../tables/plantstables/salestables/bahchi";
import CultureChart from "../../../tables/plantstables/salestables/culture";
import GrapeChart from "../../../tables/plantstables/salestables/grape";
import styled from "styled-components";
import { Button } from "antd";

const Container = styled.div`
  position: relative;
  height: 100%;
`;

const Content = styled.div`
  padding-top: 60px; /* Отступ под кнопки */
`;

const ButtonContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 999;
`;

export const SalesPlants = () => {
  const [activeTab, setActiveTab] = useState<"map" | "statistics">("map");

  const handleTabChange = (tab: "map" | "statistics") => {
    setActiveTab(tab);
  };

  return (
    <Container>
      <ButtonContainer>
        <Button
          type={activeTab === "map" ? "primary" : "default"}
          onClick={() => handleTabChange("map")}
        >
          Карта
        </Button>
        <Button
          type={activeTab === "statistics" ? "primary" : "default"}
          onClick={() => handleTabChange("statistics")}
        >
          Статистика
        </Button>
      </ButtonContainer>

      <Content>
        {activeTab === "map" ? (
          <div className={styles.mapBackground}>
            <PantsSalesMap latitude={41.5089324} longitude={74.724091} />
            <TotalPlantsTable />
            <PlantsTable />
          </div>
        ) : (
          <div className={styles.tables_plants}>
            <h2>Данные по реализации с/х продукции за год (тонн)</h2>
            <PlantBarChart />
            <div className={styles.tables}>
              <ZernoChart />
              <HlopokChart />
              <TabakChart />
              <PotatoChart />
              <VegetablesChart />
              <BahchiChart />
              <CultureChart />
              <GrapeChart />
            </div>
          </div>
        )}
      </Content>
    </Container>
  );
};
